import { render, staticRenderFns } from "./Config.vue?vue&type=template&id=5694c915&scoped=true&"
var script = {}
import style0 from "./Config.vue?vue&type=style&index=0&id=5694c915&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5694c915",
  null
  
)

export default component.exports